import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Load Paystack inline script
const script = document.createElement('script');
script.src = 'https://js.paystack.co/v1/inline.js';
script.async = true;
document.body.appendChild(script);
render(<App data-id="element-525" />, document.getElementById('root'));